import typeToReducer from 'type-to-reducer';
import { combineReducers } from 'redux';
import { createReducer, loadingStateReducer } from '../utils';

import {
  CHECK_TOKEN_CODE,
  LOGIN,
  REGISTER,
  REQUEST_PASSWORD_RESET,
  RESET_PASSWORD_NON_AUTH,
  SET_AUTHENTICATION,
  SET_LOGIN_SESSION
} from './constants';

const checkAuthCodeReducer = combineReducers({
  loadingState: loadingStateReducer(CHECK_TOKEN_CODE),
  data: typeToReducer(
    {
      [CHECK_TOKEN_CODE]: {
        START: () => null,
        ERROR: () => null
      },
      [CHECK_TOKEN_CODE]: {
        SUCCESS: (state, { payload }) => ({ ...state, ...payload })
      }
    },
    {}
  )
});

export default combineReducers({
  session: createReducer(
    {
      [SET_LOGIN_SESSION]: (state, { session }) => session,
      [SET_AUTHENTICATION]: (state, { value }) => (value ? state : null)
    },
    null
  ),
  isAuthenticated: createReducer(
    {
      [SET_AUTHENTICATION]: (state, { value }) => value
    },
    false
  ),
  login: loadingStateReducer(LOGIN),
  requestPasswordReset: loadingStateReducer(REQUEST_PASSWORD_RESET),
  resetPassword: loadingStateReducer(RESET_PASSWORD_NON_AUTH),
  register: loadingStateReducer(REGISTER),
  checkAuthCode: checkAuthCodeReducer
});
